<template lang="pug">
  base-container
    avue-crud(
      ref="crud"
      :data="data"
      :table-loading="loading"
      :option="option"
      :page.sync="page"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    )
      template(slot="agreeStatus" slot-scope="scope")
        el-tag {{scope.row.breakStatus | getObjectVal(STATUS)}}
</template>

<script>
import { getList } from '@/api/appoint'
import { STATUS } from './const'
export default {
  name: 'AppointList',
  data() {
    return {
      form: {},
      data: [],
      query: {},
      STATUS,
      loading: false,
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      option: {
        addBtn: false,
        editBtn: false,
        delBtn: false,
        searchShow: true,
        columnBtn: false,
        searchBtnText: '查询',
        emptyBtnText: '重置',
        stripe: true,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        menu: false,
        column: [
          {
            label: '伙伴昵称',
            prop: 'partnerNickname',
            search: true,
            width: 200
          },
          // {
          //   label: '伙伴手机',
          //   prop: 'partnerMobile',
          //   search: true,
          //   width: 150
          // },
          {
            label: '伙伴邮箱',
            prop: 'partnerEmail',
            search: true,
            width: 200
          }, {
            label: '约定记录',
            prop: 'agreeStatus',
            slot: true,
            width: 200
          }, {
            label: '目的地',
            prop: 'arrival',
            overHidden: true,
            width: 200
          }, {
            label: '出游时间',
            prop: 'tripStartDate',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd hh:mm:ss',
            search: true,
            searchRange: true,
            searchSpan: 12,
            width: 250,
            sortable: true
          }, {
            label: '结束时间',
            sortable: true,
            type: 'datetime',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd hh:mm:ss',
            prop: 'tripEndDate',
            width: 250
          }
        ]
      }
    }
  },
  methods: {
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      const { tripStartDate } = params
      const { userId } = this.$route.query
      let values = { ...params }
      if (tripStartDate) {
        values = {
          ...params,
          tripDateStart: tripStartDate[0],
          tripDateEnd: tripStartDate[1]
        }
        values.tripStartDate = null
        this.query.tripStartDate = null
      }
      this.loading = true
      getList(page.currentPage, page.pageSize, { ...values, userId, ...this.query }).then(res => {
        this.page.total = res.total
        this.data = res.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style>
</style>
